export type PortalRoute = {
	name: "login" | "claim" | "invite" | "projects" | "organizations" | "proposal" | "project" | "inbox";
	id?: string;
	section?:
		| "overview"
		| "conversation"
		| "spec"
		| "delivery"
		| "completion"
		| "requests"
		| "artifacts"
		| "inbox"
		| "preview";
};
export function parsePortalRoute(path = location.pathname): PortalRoute {
	if (path === "/login") return { name: "login" };
	if (path === "/claim") return { name: "claim" };
	if (path === "/invite") return { name: "invite" };
	const organization = path.match(/^\/organizations(?:\/([^/]+))?$/);
	if (organization) return { name: "organizations", id: organization[1] };
	const proposal = path.match(/^\/proposals\/([^/]+)$/);
	if (proposal) return { name: "proposal", id: proposal[1] };
	const project = path.match(
		/^\/projects\/([^/]+)\/(overview|conversation|spec|delivery|completion|requests|artifacts|inbox|preview)$/,
	);
	if (project) return { name: "project", id: project[1], section: project[2] as PortalRoute["section"] };
	const inbox = path.match(/^\/inbox\/([^/]+)$/);
	if (inbox) return { name: "inbox", id: inbox[1] };
	return { name: "projects" };
}
export function navigatePortal(path: string) {
	history.pushState({}, "", path);
	window.dispatchEvent(new PopStateEvent("popstate"));
}
